import axios from "axios";
import { internalStore } from "@/utils/LLM/localStore";
import * as qs from "qs";

const api = require("@/lib/api");
const instance = axios.create({
  headers: {
    Authorization: process.env.LLM_API_KEY
  }
});
const loginData = internalStore.get("loginData");
const instance2 = axios.create({
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    token: loginData.token,
    authenticate: loginData.authenticate
  }
});
const instance3 = axios.create({
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    token: loginData.token,
    authenticate: loginData.authenticate
  }
});
const instance4 = axios.create({
  headers: {
    Token: loginData.token
  }
});
instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 单轮对话，历史消息
export const historyMsg = (params) => {
  return instance.get("/v1/messages", {
    params
  });
};
// 会话列表
export const historyList = (params) => {
  return instance.get("/v1/conversations", {
    params
  });
};
// 停止对话
export const stopConversation = (params) => {
  return instance.post(`/v1/chat-messages/${params.taskId}/stop`, {
    user: loginData.employeeNumber
  });
};
export const getFlightOrderByOrderId = (params) => {
  return instance2.post("/order/getFlightOrderByOrderId", qs.stringify(params));
};
export const getChangePredictFee = (params) => {
  return instance2.post("/order/getChangePredictFee", qs.stringify(params));
};
export const getRefundPredictFee = (params) => {
  return instance3.post("/order/getRefundPredictFee", params);
};
export const checkLinkBroken = (params) => {
  return instance4.get(api.chat.checkLinkBroken, {
    params
  });
};
export const fetchHotelStandard = (params) => {
  return instance3.post(api.chat.hotelStandard, params);
};
export const fetchHotelReason = (params) => {
  return instance3.post(api.chat.hotelReason, params);
};
export const fetchHotelServiceFee = (params) => {
  return instance3.post(api.chat.hotelServiceFee, params);
};
export const fetchAiHotel = (params) => {
  return instance3.post(api.chat.getAiHotel, params);
};
export const fetchAiHoteRate = (params) => {
  return instance3.post(api.chat.getAiHoteRate, params);
};
// 12306账号登录
export const askForValidateTrainAccount12306 = (params) => {
  return instance3.post("/tool/askForValidateTrainAccount", params);
};
export const hdLogin = (params) => {
  return instance3.post("/hd_login/login", params);
};
// 查询登录
export const queryHdLogin = (params) => {
  return instance2.post(
    "/hd_login/queryHdAccount",
    qs.stringify({
      ...params,
      authenticate: loginData.authenticate
    })
  );
};
// 华德人脸后查询接口
export const hdFaceLogin = () => {
  return instance2.post("/hd_login/status", qs.stringify({ authenticate: loginData.authenticate }));
}
export const queryLogin = (params) => {
  return instance2.post(
    "/ykb_train/queryAccount",
    qs.stringify({
      ...params,
      authenticate: loginData.authenticate
    })
  );
};
// 短信验证
export const hdValidateTrainAccount12306 = (params) => {
  return instance2.post(
    "/hd_login/submitSms",
    qs.stringify({
      ...params,
      authenticate: loginData.authenticate
    })
  );
};
export const validateTrainAccount12306 = (params) => {
  return instance3.post("/tool/validateTrainAccount", {
    ...params,
    authenticate: loginData.authenticate
  });
};
// 人脸验证
export const getFaceIdResult = (params) => {
  return instance3.post("/tool/faceRecognition", {
    ...params,
    authenticate: loginData.authenticate
  });
};
// 华德自购人脸验证
export const hdFaceRecognition = (params) => {
  return instance2.post("/hd_login/faceLogin", params, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 获取超标/改签/退票列表
export const queryOutStandards = () => {
  return instance3.get("/ykb_train_forward/queryOutStandards", {
    params: {
      authenticate: loginData.authenticate
    }
  });
};

// 火车服务费
export const getTrainOrderFee = (params) => {
  return instance2.post(
    "/ykb_train_forward/getTrainOrderFee",
    qs.stringify(params)
  );
};

// 机票改签下单页超标接口
export const getECSFlightExceed = (params) => {
  return instance2.post(
    "/order/getECSFlightChangeExceedAndSecondApproveInfo",
    qs.stringify({ ...params, authenticate: loginData.authenticate })
  );
};
// 机票经停信息
export const getFlightStops = (params) => {
  return instance2.post(
    "/flight/getFlightStop",
    qs.stringify({ ...params, authenticate: loginData.authenticate })
  );
};
// 机票退改签规则
export const getStipulatesWithCheckAdvise = (params) => {
  return instance2
    .post(
      "/flight/getStipulatesWithCheckAdvise",
      qs.stringify({ ...params, authenticate: loginData.authenticate })
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
// 校验重复下单接口
export const checkRepeatOrder = (params) => {
  return instance2
    .post(
      "/order/checkDuplicateOrder",
      qs.stringify({ ...params, authenticate: loginData.authenticate })
    )
    .then((res) => {
      if (res.data?.Code === "SUCCESS") {
        return res.data;
      }
      return Promise.reject(res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
// 火车超标配置
export const getTrainExceedConfig = (data) => {
  return instance3.post(
    "/travelThirdparty/travel-third-party/ecs/getTravelExeedRule",
    data
  );
};
